import PropTypes from 'prop-types'
import React from 'react'

const StatsComponent = ({ numberOfEvents = null, numberOfGolfers, entryFeesSum, isUsedInMembers = false }) => {
  return (
    <div className='stats-component'>
      {numberOfEvents !== null && <div className='display-flex'>
          <div className={isUsedInMembers ? 'add-margin-right-10' : 'bold'}>
            {numberOfEvents}
          </div>
          {window.I18n.t('gg_golf_hub.dashboard.stats.events', { count: numberOfEvents })}
          <div className='line'>|</div>
        </div>}
      <div className='display-flex'>
        <div className={isUsedInMembers ? 'add-margin-right-10' : 'bold'}>
          {isUsedInMembers && <i className='fa-regular fa-flag-pennant add-margin-right-5' aria-hidden='true'></i>}
          {numberOfGolfers}
        </div>
        {window.I18n.t('gg_golf_hub.dashboard.stats.golfers', { count: numberOfGolfers })}
        <div className='line'>|</div>
      </div>
      <div className='display-flex'>
        <div className={isUsedInMembers ? 'add-margin-right-10' : 'bold'}>
          ${entryFeesSum}
        </div>
        {window.I18n.t('gg_golf_hub.dashboard.stats.entry_fees')}
      </div>
    </div>
  )
}

StatsComponent.propTypes = {
  numberOfEvents: PropTypes.number,
  numberOfGolfers: PropTypes.number,
  entryFeesSum: PropTypes.number,
  isUsedInMembers: PropTypes.bool,
}

export default StatsComponent
